import React, { Component } from "react";
import * as pr from "../../common/PrimeComponents";
import * as Log from "../../common/Feedback/Log";

export class ListValueDisplay extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: null,
      errors: [],
      imageUriList: this.props.currentImages,
      currentListProperty: ""
    };

    this.logger = Log;
  }

  render() {
    return this.getCustomValuesTable();
  }
  getCustomValuesTable = () => {
    if (this.props.values !== undefined) {
      return (
        <div className="ui-g-12" style={{ paddingTop: "2em" }}>
          <pr.DataTable
            ref={el => {
              this.dt = el;
            }}
            reorderableColumns={false}
            selectionMode="single"
            onSelectionChange={e => {}}
            value={this.props.values}
            dataKey="id"
            emptyMessage="No Properties"
            // header={
            //   <div>
            //     <label className="header-label">Accepted Values</label>
            //   </div>
            // }
            rows={100}
            autoLayout={true}
          >
            <pr.Column
              header={this.props.valuePrefix}
              body={this.valueTemplate}
              style={{ overflow: "auto", background: "white" }}
            />
          </pr.DataTable>{" "}
        </div>
      );
    } else {
      return <div></div>;
    }
  };
  valueTemplate = (rowData, column) => {
    return <label style={{ float: "middle" }}> {rowData} </label>;
  };
}



// WEBPACK FOOTER //
// ./src/components/Common/ListValueDisplay.js